/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationResponseDto
 */
export interface NotificationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    notificationType: NotificationResponseDtoNotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    body: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationResponseDto
     */
    data?: object;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationResponseDto
     */
    isRead: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NotificationResponseDto
     */
    readAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NotificationResponseDto
     */
    createdAt: Date;
}


/**
 * @export
 */
export const NotificationResponseDtoNotificationTypeEnum = {
    AppointmentReminder: 'appointment_reminder',
    AppointmentScheduled: 'appointment_scheduled',
    AppointmentTimeChanged: 'appointment_time_changed',
    TreatmentUpdate: 'treatment_update',
    ChatMessage: 'chat_message',
    SystemAlert: 'system_alert',
    Marketing: 'marketing',
    Custom: 'custom',
    NewMessage: 'new_message',
    DataSharingRequest: 'data_sharing_request',
    InstructionReminder: 'instruction_reminder',
    AskCelleraChatExport: 'ask_cellera_chat_export',
    TreatmentPlanReady: 'treatment_plan_ready',
    InstructionReady: 'instruction_ready',
    ProcedureReady: 'procedure_ready',
    ReminderOccurrence: 'reminder_occurrence',
    BiomarkerOcrReady: 'biomarker_ocr_ready',
    MedicationOcrReady: 'medication_ocr_ready'
} as const;
export type NotificationResponseDtoNotificationTypeEnum = typeof NotificationResponseDtoNotificationTypeEnum[keyof typeof NotificationResponseDtoNotificationTypeEnum];


/**
 * Check if a given object implements the NotificationResponseDto interface.
 */
export function instanceOfNotificationResponseDto(value: object): value is NotificationResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('isRead' in value) || value['isRead'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function NotificationResponseDtoFromJSON(json: any): NotificationResponseDto {
    return NotificationResponseDtoFromJSONTyped(json, false);
}

export function NotificationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'notificationType': json['notificationType'],
        'title': json['title'],
        'body': json['body'],
        'data': json['data'] == null ? undefined : json['data'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'isRead': json['isRead'],
        'readAt': json['readAt'] == null ? undefined : (new Date(json['readAt'])),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function NotificationResponseDtoToJSON(json: any): NotificationResponseDto {
    return NotificationResponseDtoToJSONTyped(json, false);
}

export function NotificationResponseDtoToJSONTyped(value?: NotificationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'notificationType': value['notificationType'],
        'title': value['title'],
        'body': value['body'],
        'data': value['data'],
        'imageUrl': value['imageUrl'],
        'isRead': value['isRead'],
        'readAt': value['readAt'] == null ? undefined : ((value['readAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

